import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import Solutions from './pages/Solutions';
import WebAIExcelPage from './pages/WebAIExcel';
import BlogPage from './pages/BlogPage';
import BlogDetailPage from './components/BlogDetailPage'
import PodcastDetailPage from './components/PodcastDetailPage'
//import PortalPage from './pages/Portal';
//import Playground from './pages/Playground';
import ContactPage from './pages/Contact';
import ThemeProvider from './components/ThemeProvider';
import AboutUs from './pages/AboutUs';

// Layout and routes without a router, so scripts/prerender.tsx can render it with StaticRouter.
export const AppShell = () => {
  return (
    <ThemeProvider>
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/webaiexcel" element={<WebAIExcelPage />} />
            <Route path="/blogs" element={<BlogPage />} />
            <Route path="/blogs/blog/:slug" element={<BlogDetailPage />} />
            <Route path="/blogs/podcast/:slug" element={<PodcastDetailPage />} />
            {/*
            <Route path="/playground" element={<Playground />} />            
            <Route path="/portal" element={<PortalPage />} />
            */}
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/about" element={<AboutUs />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </ThemeProvider>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
};

export default App;